/* eslint-disable no-console -- sink console desta fase */
import { getActiveObservabilityContext } from '../runtime';
import type { IMetricsProvider } from '../metrics/types';
import type { IWebVitalMetric } from '../types';

export class ConsoleMetricsProvider implements IMetricsProvider {
  increment(name: string, value = 1): void {
    const ctx = getActiveObservabilityContext();
    if (ctx) {
      console.debug('[metrics:increment]', name, value, { ctx });
      return;
    }
    console.debug('[metrics:increment]', name, value);
  }

  gauge(name: string, value: number): void {
    const ctx = getActiveObservabilityContext();
    if (ctx) {
      console.debug('[metrics:gauge]', name, value, { ctx });
      return;
    }
    console.debug('[metrics:gauge]', name, value);
  }

  timing(name: string, durationMs: number): void {
    const ctx = getActiveObservabilityContext();
    if (ctx) {
      console.debug('[metrics:timing]', name, `${durationMs.toFixed(1)}ms`, { ctx });
      return;
    }
    console.debug('[metrics:timing]', name, `${durationMs.toFixed(1)}ms`);
  }

  recordWebVital(metric: IWebVitalMetric): void {
    // ponytail: stub até fase 2 ligar web-vitals
    const ctx = getActiveObservabilityContext();
    if (ctx) {
      console.debug('[metrics:web-vital]', metric.name, metric.value, metric.rating, { ctx });
      return;
    }
    console.debug('[metrics:web-vital]', metric.name, metric.value, metric.rating);
  }

  async flush(): Promise<void> {}

  async shutdown(): Promise<void> {}
}
